import React, { useState } from 'react'

import List from '@mui/material/List';

import Divider from '@mui/material/Divider';

import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useAppContext } from 'app/AppContext';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';



import Help from '@mui/icons-material/Help';
import * as Icons from '@mui/icons-material';
import { Collapse, Typography } from '@mui/material';

import "./style.css"
import SwitchDB from './components/SwitchDB';
import { usePerfil, useUserUid } from 'useAuth';
import { flog } from 'util/FileLogger';

const ItemMenu = ({ menu, handleDrawerClose, colorInvert }) => {

    let classesNameUsar = colorInvert ? "menuSecundario" : "menuPrimario"
    const [expanded, setExpanded] = useState(false)
    const expandAction = () => {
        setExpanded(!expanded)
    }


    const actionClick = () => {
        if (menu.action) {
            flog('Menu Click: ' + menu.text)
            menu.action();
            if (handleDrawerClose) handleDrawerClose()
        }

    }
    let iconeAux = ""
    let iconeUsar = <Help className={classesNameUsar} />;

    if (menu.icone) {
        let Teste = menu.icone
        iconeUsar = <Teste className={classesNameUsar} />;
    }
    if (menu.iconeStr) {
        const RecIcon = Icons[menu.iconeStr]
        iconeUsar = <RecIcon className={classesNameUsar} />;
    }
    if (menu.iconName) {
        const RecIcon = Icons[menu.iconName]
        iconeUsar = <RecIcon className={classesNameUsar} />;
    }


    if (menu.children) {
        return <>
            <ListItem button onClick={expandAction} className={classesNameUsar}>
                <ListItemIcon>
                    {iconeUsar}
                </ListItemIcon>

                <ListItemText
                    disableTypography
                    primary={<Typography className={classesNameUsar} ><span>{menu.text} {iconeAux}</span></Typography>}
                />
                {menu.children && <>{expanded ? <ExpandLess className={classesNameUsar} /> : <ExpandMore className={classesNameUsar} />}</>}
            </ListItem>
            {menu.children &&
                <Collapse in={expanded} timeout="auto" unmountOnExit className={'menuSecundario'}>
                    {menu.children.map((m, i) => <ItemMenu key={"submenu" + m.text + i} menu={m} colorInvert={!colorInvert} handleDrawerClose={handleDrawerClose} />)}
                </Collapse>
            }
        </>
    }
    return <ListItem button onClick={actionClick} className={classesNameUsar}>
        <ListItemIcon>
            {iconeUsar}
        </ListItemIcon>
        <ListItemText
            disableTypography
            primary={<Typography className={classesNameUsar} ><span>{menu.text} {iconeAux}</span></Typography>}
        />
    </ListItem>
}
export default function MenuControl({ handleDrawerClose }) {
    const { menus } = useAppContext()
    const isAuthenticated = useUserUid();
    const perfil = usePerfil();
    return (
        <>
            <Divider />
            <List className={'menuPrimario'}>
                {menus && <>
                    {menus.map((menu, index) => <ItemMenu key={index} menu={menu} handleDrawerClose={handleDrawerClose} />)}
                </>}
            </List>
            <Divider />
            {isAuthenticated && <SwitchDB closeMenu={handleDrawerClose} />}

            <div style={{ color: "#fff", textAlign: "center", padding: 5, fontSize: 'small' }}>
                {perfil ? perfil.email : ""}
            </div>
            <div style={{ color: "#fff", textAlign: "center", padding: 5, fontSize: 'small' }}>
                {process.env.REACT_APP_VERSION}<br /> {process.env.REACT_APP_VERSION_DATE}
            </div>
        </>
    )
}
